import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
// import BaseList from '../../Components/common/BaseList';
import { Row, Col, Icon, Table, Card } from 'antd';
import { getOraganizations } from '../../api/OraganizationApis';
import { withAppContext } from '../../store/contextStore';
import { showTotal } from '../commonFunctions';

class Oraganizations extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: <div className='list-head'>Name</div>,
        dataIndex: 'orgName',
        className: 'list-data',
        key: 'orgName',
        align: 'left',
      },
      {
        title: <div className='list-head'>Address</div>,
        dataIndex: 'address',
        className: 'list-data',
        key: 'address',
        align: 'left',
        render: (address, data) => (
          <span>{address}</span>
        ),
      },
      {
        title: <div className='list-head'>Email</div>,
        dataIndex: 'email',
        className: 'list-data',
        key: 'email',
        align: 'left',
        render: (email, data) => (
          <span>{email}</span>
        ),
      },
      {
        title: <div className='list-head'>Phone</div>,
        dataIndex: 'phone',
        className: 'list-data',
        key: 'phone',
        align: 'left',
        render: (phone, data) => (
          <span>{phone}</span>
        ),
      },
      {
        title: <div className='list-head'>View</div>,
        className: 'list-data',
        key: 'view',
        align: 'left',
        render: data => (
          <Link to={ `/app/oraganization_details/${data.id}` } >
            <Icon type='eye' theme='filled' />
          </Link>
        ),
      },
    ];
    this.state = {
      leadsData: [],
      filterData: [],
      oraganizationsData:[],
      dataLoadingStatus: true
    };
  }
  componentDidMount() {
    getOraganizations()
      .then(result => {
        if (result.success) {
          this.setState({
            oraganizationsData: result.data,
            dataLoadingStatus: false
            // filterData: result.data,
          });
        } else {
          console.log(result.errors);
        }
      });
  }
  render() {
    return (
      <div className="site-card-border-less-wrapper" style={{ margin: "40px 90px" }}>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
                <h1 className="headings"> Oraganizations &nbsp;
                  <Link to='/app/add_oraganization'>
                    <i className='fa fa-plus-circle' style={ { color: '#40a9ff' } } />
                  </Link>
                </h1>
            </Col>
          </Row>
          <Row style={{marginTop:"20px"}}>
              <Card>
                  {/* <h1 style={{ color: "rgb(14, 77, 144)" }}>All Orders</h1> */}
                  <Table
                      columns={this.columns}
                      dataSource={this.state.oraganizationsData}
                      style={{ marginTop: "2%" }}
                      loading={this.state.dataLoadingStatus}
                      rowKey={record => record.id}
                      pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10','25', '50', '100'], total: this.state.oraganizationsData.length, showTotal: showTotal}}
                  />
              </Card>
          </Row>
      </div>
    );
  }
}

export default withAppContext(withRouter(Oraganizations));